import Timeline from './Timeline';


Timeline.install = function(Vue) {
  Vue.component(Timeline.name, Timeline);
};

export default Timeline;
